import { browser } from '$app/environment'
import { apiFetchJson, type CookieItem } from '$lib/proxy/apiProxy'
import { isSubscriptionNeeded } from '$lib/stores/account/manager'
import type { SubscriptionAccountPlanFeature } from '$lib/types/subscription_types'

export const enum Features_Name {
	Notification_Viewed = 'notification_viewed',
	Invoices_Tracking = 'invoices_tracking',
	Payments_Reminders = 'payments_reminders',
	Attachments_Limit = 'attachments_limit',
	AI_Expenses = 'ai_expenses',
	AI_Assistant = 'ai_assistant',
	Automation = 'automation',
	Receipts_Send = 'receipts_send',
	Emails_Limit = 'emails_limit',
	Team_Users = 'team_users'
}

// change this store to a local variable.
// export const storeAccSubPlanFeatures = writable([] as SubscriptionAccountPlanFeature[])
let accSubPlanFeatures: SubscriptionAccountPlanFeature[] = []

let promiseFetch: Promise<SubscriptionAccountPlanFeature[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

export const InitAccSubPlanFeatures = async (pFetch = fetch) => {
	if (!browser) return
	if (state === 'ready') return
	if (state === 'reading') {
		await promiseFetch
		return
	}

	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return
}

const fetchData = async (pFetch = fetch, myCookie?: CookieItem[]) => {
	state = 'reading'

	// const jsonData = await getSubscriptionAccountPlanFeatures(pFetch)

	const jsonData = await apiFetchJson(pFetch, 'get', '/subscription/accountplanfeatures', myCookie)
	if (!jsonData || jsonData.error) {
		state = 'pending'
		return
	}

	const data = jsonData
	// if (browser) storeAccSubPlanFeatures.set(data)
	if (browser) {
		accSubPlanFeatures = data
		state = 'ready'
	}
	return data
}

// UP generic ==== Down custom ===================

export const AccPlanHasFeatureEnabled = (feature_name: Features_Name): boolean => {
	// const accSubscriptionPlanFeatures = get(storeAccSubPlanFeatures)
	const accSubscriptionPlanFeatures = accSubPlanFeatures

	// Added that if the account is in the free trial period, it behaves as an 'trial' plan
	if (isSubscriptionNeeded()) return false


	const feature = accSubscriptionPlanFeatures.find(
		(feature) => feature.name_internal === feature_name
	)

	if (feature) {
		return true
	}
	//
	return false
}


export const getAccPlanFeatures = (feature_name: Features_Name) => {
	// await InitAccSubPlanFeatures()
	const feature = accSubPlanFeatures.find(
		(feature) => feature.name_internal === feature_name
	)
	return feature
}

